/**
 * DatePicker.react.js
 *
 */
import React, { Component } from 'react';
import Calendar from 'rc-calendar/lib/Calendar';
import Picker from 'rc-calendar/lib/Picker';
import 'rc-time-picker/assets/index.css';
import TimePickerPanel from 'rc-time-picker/lib/Panel';
import now from 'moment';
import jaLocale from 'rc-calendar/lib/locale/ja_JP';
import enLocale from 'rc-calendar/lib/locale/en_US';
// Update Message
enLocale.timeSelect = "Select Time";
enLocale.dateSelect = "Select Date";
enLocale.ok = "OK";


require('rc-calendar/assets/index.css');

class DatePicker extends Component {

  constructor(props) {
    super(props);
    if(props.locale === 'ja') {
      now.locale('ja');
    }
    const dataType = props.dataType; // either "Date" or "POSIXct".
    const showTime = dataType === "POSIXct";
    if(props.uiLang) {
      now.locale();
    }
    this.state = { 
      value: this.props.value ? now(this.props.value): "",
      showTime: showTime,
      showToday: this.props.showToday,
      format: dataType === "POSIXct" ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD"
    };

    this.calendarContainerRef = React.createRef();
  } 


  /**
   * [description]
   * @return {[type]} [description]
   */
  getInitialState() {
    if(this.props.locale === 'ja') {
      now.locale('ja');
    }
    const dataType = this.props.dataType; // either "Date" or "POSIXct".
    const showTime = dataType === "POSIXct";
    if(this.props.uiLang) {
      now.locale();
    }
    return { 
      value: this.props.value ? now(this.props.value): "",
      showTime: showTime,
      showToday: this.props.showToday,
      format: dataType === "POSIXct" ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD"
    };
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.value !== this.props.value) {
      this.setState({value: nextProps.value ? now(nextProps.value) : nextProps.value});
    }
  }

  /**
   * [description]
   * @param  {[type]} ev [description]
   * @return {[type]}    [description]
   */
  onChange(value) {
    const name = this.props.name; 
    if (this.props.onChange) {
      this.props.onChange(value ? value.format(this.state.format) : '');
    } else {
      this.setState({ value: value });
    }
  }

  onClear() {
    setTimeout(() => {
      this.setState({
        open : true,
        value: ''
      });
    });
  }
 
  onOpenChange(open) {
    let currentValue = this.state.value;
    if (!open && !currentValue) {
      currentValue = now('00:00:00', 'HH:mm:ss');
      if (this.disabledDate(currentValue)) {
        if (this.props.max) {
          currentValue = now(this.props.max);
        } else if (this.props.min) {
          currentValue = now(this.props.min);
        }
      }
      this.setState({
        open : open,
        value: currentValue
      });  
      this.props.onChange(currentValue ? currentValue.format(this.state.format) : '');
    } else {
      this.setState({
        open : open,
      });  
    }
  }

  onMouseDown() {
    this.setState({
      isMouseDown: true,
    });
  }

  onFocus() {
    if (!this.state.open && this.state.isMouseDown) {
      // focus from a "click" event, let the picker trigger automatically open the calendar
      this.setState({
        isMouseDown: false,
      });
    } else {
      // focus not caused by "click" (such as programmatic or via keyboard)
      this.setState({
        open: true,
      });
    }
  }

  getCalendarContainer(){
    return this.calendarContainerRef.current;
  }

  disabledDate(current) {
    if (!current) {
      // allow empty select
      return false;
    }
    const min = this.props.min;
    const max = this.props.max;

    if(min && max) {
      const minDate = now(min);
      const maxDate = now(max);  
      return current.valueOf() < minDate.valueOf() || current.valueOf() > maxDate.valueOf();
    } else if (min) {
      const minDate = now(min);
      return current.valueOf() < minDate.valueOf();
    } else if (max) {
      const maxDate = now(max);  
      return current.valueOf() > maxDate.valueOf();
    }
    return false;
  }

  /**
   * [description]
   * @return {[type]} [description]
   */
  render() {
    if(this.props.locale === 'ja') {
      now.locale('ja');
    } else {
      now.locale('en');
    }
    const id = this.props.id;
    const value = this.state.value;
    const locale = this.props.locale === 'ja' ? jaLocale : enLocale;
    const calendar = (
      <Calendar
        locale={locale}
        format={this.state.format}
        dateInputPlaceholder={value ? value.format(this.state.format) : ""}
        timePicker={this.state.showTime ? <TimePickerPanel defaultValue={now('00:00:00', 'HH:mm:ss')} /> : null}
        disabledDate={this.disabledDate.bind(this)}
        defaultValue={value ? value : now()}
        focusablePanel={false}
        onClear={this.onClear.bind(this)}
      />
    );
    
    const placeHolder = value ? value.format(this.state.format) : (this.props.defaultPlaceholder || "Choose...") 
    return (
      <div id={id} className="widget-datetime-picker">
        <Picker
          calendar={calendar}
          value={value}
          onChange={this.onChange.bind(this)}
          getCalendarContainer={this.getCalendarContainer.bind(this)}
          onOpenChange={this.onOpenChange.bind(this)}
          open={this.state.open}
          style={{ zIndex: 1081 }}>
          {
            ({val}) => {
              return (
                <span tabIndex={0} 
                  onMouseDown={this.onMouseDown.bind(this)} 
                  onFocus={this.onFocus.bind(this)}>
                  <input
                    placeholder={placeHolder}
                    disabled={!!this.state.disabled}
                    readOnly
                    tabIndex={-1}
                    className="ant-calendar-picker-input ant-input"
                    value={val && val.format(this.state.format) || ''}
                  />
                  <div ref={this.calendarContainerRef} />
                </span>
              );
            }
          }  
        </Picker> 
      </div>
    );
  }
};

export default DatePicker;
